import { Box } from "@mui/material";
import { useStore } from "@tanstack/react-form";
import { ButtonGroup } from "react-bootstrap";

import { useLoadPpCountsQuery } from "api/public/protectionProfiles/protectionProfiles.api";
import { withForm } from "components/Forms/AppForm";

import { ppFilterDefaultValues } from "../../context/ppFilterDefaultValues";

import HeaderInfoButton from "./HeaderInfoButton";

const HeaderInfo = withForm({
  defaultValues: ppFilterDefaultValues,
  render: function Render({ form }) {
    const { data: ppCounts, isLoading } = useLoadPpCountsQuery();
    const archived = useStore(form.store, (state) => state.values.archived);

    const { approved = 0, archived: archivedCount = 0 } = ppCounts || {};

    const title = archived
      ? `Archived Protection Profiles - ${archivedCount}`
      : `Approved Protection Profiles - ${approved}`;

    const handleArchivedChange = (isArchived: boolean) => {
      form.setFieldValue("archived", isArchived);
    };

    return (
      <Box
        padding={5}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <h3 className="fw-bold text-primary text-uppercase">{title}</h3>

        <ButtonGroup>
          <HeaderInfoButton
            active={!archived}
            label={"Approved Protection Profiles"}
            count={approved}
            isLoading={isLoading}
            onClick={() => handleArchivedChange(false)}
          />

          <HeaderInfoButton
            active={archived}
            label={"Archived Protection Profiles"}
            count={archivedCount}
            isLoading={isLoading}
            onClick={() => handleArchivedChange(true)}
          />
        </ButtonGroup>
      </Box>
    );
  },
});

export default HeaderInfo;
